import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { weiToNum } from 'toolbelt'
import PoolSelector from 'components/PoolSelector'

import SupplyButton from 'components/Buttons/BorrowButton'
import BN from 'bn.js'

import { usePaladin } from 'hooks'
import { useAppState } from 'state'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '40%',
    margin: 'auto',
    border: '1px solid #A5A5A5',
    borderRadius: '4px',
    marginTop: '5rem',
  },
  form: {
    width: '65%',
    margin: 'auto',
    marginTop: '3.5rem',
    marginBottom: '1.5rem',
  },
  label: {
    marginTop: '2rem',
    marginBottom: '.5rem',
  },
  votingPower: {
    display: 'flex',
    flexDirection: 'row',
  },
  votingInput: {
    width: '205px',
    height: '35px',
  },
  max: {
    marginLeft: '1rem',
    alignSelf: 'center',
    color: '#A5A5A5',
    fontSize: 14,
    cursor: 'pointer',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
    color: '#A5A5A5',
  },
  fee: {
    width: '70%',
  },
  feeInput: {
    width: '100%',
  },
  feeBalance: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  feeInfoTitle: {
    color: '#A5A5A5',
    fontSize: 12,
  },
  feeInfo: {
    color: '#A5A5A5',
    fontSize: 12,
    marginLeft: '1rem',
  },
  borrow: {
    margin: 'auto',
    marginTop: '2rem',
    marginBottom: '1rem',
    display: 'flex',
    justifyContent: 'center',
  },
}))

//  vAave balance (in Wei) * exchange Rate / 1e18
const calcUnderlying = (vBalance: string, exchangeRate: string) => {
  const res = new BN(vBalance)
    .mul(new BN(exchangeRate))
    .div(new BN(10).pow(new BN(18)))
    .toString()
  return weiToNum(res)
}

const WithdrawTab = () => {
  const styles = useStyles()
  const { vpoolBalance, exchangeRate } = useAppState()
  const [input, setInput] = React.useState('')
  const { withdraw } = usePaladin()
  const underlying = calcUnderlying(vpoolBalance, exchangeRate)
  return (
    <Box>
      <PoolSelector isBorrow={false} />
      <Typography className={styles.label}>Output</Typography>
      <Box className={styles.fee}>
        <input className={styles.votingInput} value={input} onChange={(e) => setInput(e.target.value)} />
        <Box className={styles.feeBalance}>
          <Typography className={styles.feeInfoTitle}>Deposited Balance</Typography>
          <Typography className={styles.feeInfo}>{underlying} AAVE</Typography>
        </Box>
      </Box>
      <Box className={styles.borrow}>
        <SupplyButton
          onClick={() => {
            withdraw(input)
          }}
        >
          Withdraw
        </SupplyButton>
      </Box>
    </Box>
  )
}

export default WithdrawTab
